const $inject = [];

const lbaSelect = function () {
  return {
    restrict: 'A',
    scope:{
      settings: '=settings'
    },
    bindToController: true,
    controller: 'lbaSelectCtrl',
    controllerAs: 'vm',
    template: require('./lbaSelect.html')
  }
};

lbaSelect.$inject = $inject;

export default lbaSelect;



// WEBPACK FOOTER //
// ./src/components/lbaSelect/lbaSelectDir.js